module.exports = __webpack_public_path__ + "img/ukrine-min.b0863ad.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/countries/ukrine-min.png
// module id = YVJQ
// module chunks = 1